<template>
  <path d="M4.5 15.7L12 8.19995L19.5 15.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</template>